export const getPVP = (markupPercent: number, cost: number): number => {
  const markup = markupPercent * 0.01;
  const realMarkup = 1 - markup;
  return cost / realMarkup;
};
